import React from "react";
import { Grid, Label, Icon, Popup, Button } from "semantic-ui-react";
import moment from "moment";

const getDelayPreregister = (preregister) => {
	if (preregister && !preregister.folder) return -1;
	if (preregister && preregister.folder && !preregister.folder.labAppointment) return -2;
	return (
		moment(`${preregister.folder?.labAppointment?._date} ${preregister.folder?.labAppointment?._time}`).diff(preregister.created_at, "minutes") + 1
	);
};
const formatDelay = (delay) => {
	if (delay === undefined || delay === 0) return "";
	if (delay === -1) return "Erreur";
	if (delay === -2) return "En attente";
	if (delay < 60) return `${delay} min`;
	if (delay < 60 * 24) return `${Math.floor(delay / 60)}h${delay % 60}`;
	return `${Math.floor(delay / (60 * 24))}j ${Math.floor((delay % (60 * 24)) / 60)}h`;
};

const getEmailInfoPreregister = (preregister) => {
	if (preregister && preregister.recallDate) {
		return (
			<Label color="teal" basic>
				{" "}
				<Icon name="mail" />
				Email ordonnance envoyé le {moment(preregister.recallDate).format("DD/MM/YYYY à HH:mm")}
				{preregister.recallIdReceived && (
					<Label.Detail style={{ fontSize: "0.8em" }}>
						Retour patient reçu le {moment(preregister.recallIdReceived).format("DD/MM/YYYY à HH:mm")}
					</Label.Detail>
				)}
			</Label>
		);
	}
};
const getStatusPreregister = (preregister) => {
	if (preregister && !preregister.folder)
		return (
			<Label color="red">
				<Icon name="warning" />
				Erreur dans la création du dossier
			</Label>
		);
	if (preregister && preregister.deleted) {
		return (
			<Label>
				<Icon name="remove" />
				Pré-inscription supprimée le {moment(preregister.deletedDate).format("DD/MM/YYYY")}
			</Label>
		);
	}
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.folderHelp &&
		preregister.folder.status === "HELP_NURSE" &&
		preregister.folder.folderHelp.status === "REASSIGNED"
	)
		return (
			<Label>
				{" "}
				<Icon name="clock" />
				En attente de la venue du patient
			</Label>
		);
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.folderHelp &&
		preregister.folder.status === "HELP_NURSE" &&
		(preregister.folder.folderHelp.status === "NEW" || preregister.folder.folderHelp.status === "PENDING")
	)
		return (
			<Label color="orange">
				{" "}
				<Icon name="bell" />
				Au télésecrétariat
			</Label>
		);
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.folderHelp &&
		(preregister.folder.folderHelp.status === "CANCELED" || preregister.folder.folderHelp.status === "CANCELEDBYSEC")
	) {
		return (
			<>
				<Label basic>
					{" "}
					<Icon name="user cancel" />
					Annulé par le secrétariat
					{preregister.folder.folderHelp?.comments?.some((c) => c.cancellation) && (
						<Label.Detail style={{ fontSize: "0.9em" }}>
							Raison : {preregister.folder.folderHelp.comments.filter((c) => c.cancellation)[0].cancelReason?.label}
						</Label.Detail>
					)}
				</Label>
			</>
		);
	}

	if (preregister && preregister.folder && preregister.folder.status === "CANCELED") {
		return (
			<Label color="black">
				{" "}
				<Icon name="cancel" />
				Dossier annulé
			</Label>
		);
	}
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.folderHelp &&
		preregister.folder.status === "DONE" &&
		preregister.folder.folderHelp.status === "DONE"
	)
		return (
			<Label color="green">
				{" "}
				<Icon name="clipboard check" />
				Terminé
			</Label>
		);
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.folderHelp &&
		preregister.folder.status === "PENDING" &&
		preregister.folder.folderHelp.status === "DONE"
	)
		return (
			<Label color="orange">
				{" "}
				<Icon name="edit" />
				Dossier en cours
			</Label>
		);
	return "???";
};
const getCallBackInfoPreregister = (preregister) => {
	if (preregister && !preregister.folder) return "";
	if (
		preregister &&
		preregister.folder &&
		preregister.folder.status !== "DONE" &&
		preregister.folder.prescriptions &&
		preregister.folder.prescriptions.length > 0
	) {
		const prescription = preregister.folder.prescriptions[0];
		if (moment(prescription.validity_date) < moment().add(-1, "days")) {
			return (
				<>
					<br />
					{preregister.callBack10 && preregister.callBack10Date
						? "Rappel -10j : envoyé le " + moment(preregister.callBack10Date).format("DD/MM/YYYY")
						: "Rappel -10j : non envoyé"}
					<br />
					{preregister.callBack2 && preregister.callBack2Date
						? "Rappel -2j : envoyé le " + moment(preregister.callBack2Date).format("DD/MM/YYYY")
						: "Rappel -2j : non envoyé"}
				</>
			);
		} else {
			return (
				<>
					<br />
					{preregister.callBack10
						? preregister.callBack10Date
							? "Rappel -10j : envoyé le " + moment(preregister.callBack10Date).format("DD/MM/YYYY")
							: "Rappel -10j : non envoyé"
						: "Rappel -10j : sera envoyé le " + moment(prescription.validity_date).add(-10, "days").format("DD/MM/YYYY")}
					<br />
					{preregister.callBack2
						? preregister.callBack2Date
							? "Rappel -2j : envoyé le " + moment(preregister.callBack2Date).format("DD/MM/YYYY")
							: "Rappel -2j : non envoyé"
						: "Rappel -2j : sera envoyé le " + moment(prescription.validity_date).add(-2, "days").format("DD/MM/YYYY")}
				</>
			);
		}
	}
	return "";
};

const PreregisterRow = ({ preregister, index }) => (
	<Grid.Row style={{ backgroundColor: "white", marginLeft: "15px", marginBottom: "1px", fontSize: "0.8rem" }}>
		<Grid.Column computer={1} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
			<Popup
				content="Cliquer pour copier le QR-code"
				trigger={<Button icon="qrcode" onClick={() => navigator.clipboard.writeText(preregister.qr_code)} />}
			/>
			<br />
		</Grid.Column>
		<Grid.Column computer={4} style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
			{preregister.birth_name} {preregister.first_name} <br />
			{preregister.gender === "m" || preregister.gender === "male" ? "Homme" : "Femme"} - {moment().diff(preregister.birth_date, "years").toString()}{" "}
			ans <br />
			{preregister.mylab_id && (
				<>
					<Label color="teal">Patient MyLab</Label> <br />
				</>
			)}
			Pré-inscription reçue le {moment(preregister.created_at).format("DD/MM/YYYY à HH:mm")}
		</Grid.Column>

		<Grid.Column computer={4} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
			{preregister.folder?.prescriptions?.length === 0 && `Aucune prescription`}
			{preregister.folder?.prescriptions?.length === 1 && preregister.folder?.prescriptions[0].no_prescriber && `Demande sans prescripteur`}
			{preregister.folder?.prescriptions?.length === 1 &&
				preregister.folder.prescriptions[0].prescriber &&
				`Prescription de ${preregister.folder.prescriptions[0].prescriber.title} ${preregister.folder.prescriptions[0].prescriber.last_name} ${preregister.folder.prescriptions[0].prescriber.first_name}`}
			<br />
			{preregister.folder?.prescriptions?.length === 1 &&
				preregister.folder.prescriptions[0].issue_date &&
				`Délivrée le ${moment(preregister.folder.prescriptions[0].issue_date).format("DD/MM/YYYY")}`}
			<br />
			{preregister.folder?.prescriptions?.length === 1 &&
				preregister.folder.prescriptions[0].validity_date &&
				`Valide jusqu'au ${moment(preregister.folder.prescriptions[0].validity_date).format("DD/MM/YYYY")}`}
			{preregister.folder?.prescriptions?.length > 0 && preregister.folder.prescriptions[0].validity_date && getCallBackInfoPreregister(preregister)}
		</Grid.Column>

		<Grid.Column computer={2} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flexDirection: "column" }}>
			<Label color={preregister.is_at_center ? "teal" : "orange"}>{preregister.is_at_center ? "En centre" : "Hors centre"}</Label>
			{preregister.folder?.labAppointment && (
				<Label>
					{" "}
					{`Scanné au ${preregister.folder.labAppointment.center.name} le ${moment(preregister.folder.labAppointment._date).format(
						"DD/MM/YYYY"
					)} à ${preregister.folder.labAppointment._time.substring(preregister.folder.labAppointment._time.length - 3, 0)}`}
				</Label>
			)}
		</Grid.Column>
		<Grid.Column computer={5} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flexDirection: "column" }}>
			{getDelayPreregister(preregister) > 0 && (
				<>
					<span>Délai de prise en charge : {formatDelay(getDelayPreregister(preregister))}</span>
					<br />
				</>
			)}
			{getStatusPreregister(preregister)}

			{getEmailInfoPreregister(preregister)}
		</Grid.Column>
	</Grid.Row>
);
export default PreregisterRow;
